export default {
  meetings: null,
  meetingsTree: null,
  meetingsCount: null,
  meetingsFilters: {
    employeeName: null,
  },
  meeting: null,
  questions: null,
  questionsDirectory: null,
  comments: null,
  tasks: null,
  isLoading: false,
  isSubmitting: false,
  errors: null,
  validationErrors: null,
};
